<!--
 * @Description: 搜索列表页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-02 14:11:41
 * @LastEditors: 山淑兰
 -->
<template>
    <div class="searchlist">
        <div class="loading" v-if="loading">
            <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
        </div>
        <div v-else>
            <div class="searchlist-con">
                <div class="details-return" @click="goBack()">
                    <img src="../../../assets/back.png">
                </div>
                <template v-if="$i18n.locale === 'zh-CN'">
                    <div class="details-main">
                        <div v-for="(item, index) in datas" :key="index">
                            <div class="details-main-head">
                                <van-cell :title="item[0].createdTime" icon="send-gift-o" class="details-main-head-date" />
                            </div>
                            <van-cell class="details-main-con" v-for="(i, id) in item" :key="id">
                                <div class="meeting-list" v-if="i.url!=null">
                                    <div class="meeting-left">
                                        <van-cell icon="underway-o" class="major-titles">
                                            {{ i.startTime + '-' + i.endTime }}
                                        </van-cell>
                                        <a :href="i.url" target="_top" v-if="i.roomTitle || i.roomName">
                                            <van-cell
                                                icon="location-o"
                                                class="major-title">
                                            {{  i.roomName }}</van-cell>
                                        </a>
                                        <van-cell icon="orders-o" class="major-title">
											<span v-html="nToBr(i.topic)"></span>
                                        </van-cell>
                                        <van-cell class="major-title" icon="user-o" v-if="i.roleName">
                                            <span v-for="(m, j) in i.exData" :key="j" style="display: block;">
                                                {{ m.rolename }}
                                              <div class="talker-name-p" style="color: #3b82f6; margin: 5px 0;"
                                                    v-for="(s, k) in m.exname"
                                                    :key="k"
                                                    @click.stop="todetails(m.exid[k])">
                                                    <p v-html="nToBr(s)"></p>
                                                    <p v-if="m.excompany[k]!=null&&m.excompany[k]!=''"  v-html="nToBr(m.excompany[k])"></p>
                                                </div>
                                            </span>
                                        </van-cell>
                                    </div>
                                    <div class="meeting-icon">
                                        <a :href="i.url" target="_top">
                                            <p><img src="../../../assets/creame3.png">
                                                观看直播</p>
                                        </a>
                                    </div>
                                </div>
                                <div class="meeting-list" v-if="i.url==null" @click="goMeeting($event,i.dateid,i.roomid)">
                                    <div class="meeting-left">
                                        <van-cell icon="underway-o" class="major-title">
                                            {{ i.startTime + '-' + i.endTime }}
                                        </van-cell>
                                        <a :href="i.url" target="_top" v-if="i.roomTitle || i.roomName">
                                            <van-cell
                                                icon="location-o"
                                                class="major-title">
                                            {{ i.roomName }}</van-cell>
                                        </a>
                                        <van-cell icon="orders-o" class="major-title">
											<span v-html="nToBr(i.topic)"></span>
										</van-cell>
                                        <van-cell class="major-title" icon="user-o" v-if="i.roleName">
                                            <span v-for="(m, j) in i.exData" :key="j" style="display: block;">
                                                {{ m.rolename }}
                                              <div class="talker-name-p" style="color: #3b82f6; margin: 5px 0;"
                                                    v-for="(s, k) in m.exname"
                                                    :key="k"
                                                    @click.stop="todetails(m.exid[k])">
                                                    <p v-html="nToBr(s)"></p>
                                                    <p v-if="m.excompany[k]!=null&&m.excompany[k]!=''"  v-html="nToBr(m.excompany[k])"></p>
                                                </div>
                                            </span>
                                        </van-cell>
                                    </div>
                                    <div class="meeting-icons">
                                        <img class="arrow" src="../../../assets/arrow-r.png">
                                    </div>
                                </div>
                            </van-cell>
                        </div>
                    </div>
                </template>
				<template v-else>
					<div class="details-main">
					    <div v-for="(item, index) in datas" :key="index">
					        <div class="details-main-head">
					            <van-cell :title="item[0].createdTime" icon="send-gift-o" class="details-main-head-date" />
					        </div>
					        <van-cell class="details-main-con" v-for="(i, id) in item" :key="id">
					            <div class="meeting-list" v-if="i.url!=null">
					                <div class="meeting-left">
					                    <van-cell icon="underway-o" class="major-titles">
					                        {{ i.startTime + '-' + i.endTime }}
					                    </van-cell>
					                    <a :href="i.url" target="_top" v-if="i.roomTitle || i.roomName">
					                        <van-cell
					                            icon="location-o"
					                            class="major-title">
											    {{ i.roomEnName!=null && i.roomEnName!=''?i.roomEnName:i.roomName }}
											</van-cell>
					                    </a>
					                    <van-cell icon="orders-o" class="major-title">
											<span  v-html="i.entopic!=null && i.entopic!='' ? nToBr(i.entopic) : nToBr(i.topic)"></span>
					                    </van-cell>
					                    <van-cell class="major-title" icon="user-o" v-if="i.roleName">
					                        <span v-for="(m, j) in i.exData" :key="j" style="display: block;">
					                            {{ m.rolename }}
					                          <div class="talker-name-p" style="color: #3b82f6; margin: 5px 0;"
					                                v-for="(s, k) in m.exname"
					                                :key="k"
					                                @click.stop="todetails(m.exid[k])">
                                                    <p v-html="m.exname[k].exenname!=''&&m.exname[k].exenname!=null?nToBr(m.exname[k].exenname):nToBr(s)"></p>
					                                <i v-if="m.excompany[k]!=null&&m.excompany[k]!=''"
                                                        v-html="m.exencompany[k]!=''&&m.exencompany[k]!=null?nToBr(m.exencompany[k]):nToBr(m.excompany[k])">
					                                </i>
					                            </div>
					                        </span>
					                    </van-cell>
					                </div>
					                <div class="meeting-icon">
					                    <a :href="i.url" target="_top">
					                        <p><img src="../../../assets/creame3.png">
					                            观看直播</p>
					                    </a>
					                </div>
					            </div>
					            <div class="meeting-list" v-if="i.url==null" @click="goMeeting($event,i.dateid,i.roomid)">
					                <div class="meeting-left">
					                    <van-cell icon="underway-o" class="major-title">
					                        {{ i.startTime + '-' + i.endTime }}
					                    </van-cell>
					                    <a :href="i.url" target="_top" v-if="i.roomTitle || i.roomName">
					                        <van-cell
					                            icon="location-o"
					                            class="major-title">
												{{ i.roomEnName!=null && i.roomEnName!=''?i.roomEnName:i.roomName }}
											</van-cell>
					                    </a>
					                    <van-cell icon="orders-o" class="major-title">
											<span  v-html="i.entopic!=null && i.entopic!='' ? nToBr(i.entopic) : nToBr(i.topic)"></span></van-cell>
					                    <van-cell class="major-title" icon="user-o" v-if="i.roleName">
					                        <span v-for="(m, j) in i.exData" :key="j" style="display: block;">
					                            {{ m.rolename }}
					                          <div class="talker-name-p" style="color: #3b82f6; margin: 5px 0;"
					                                v-for="(s, k) in m.exname"
					                                :key="k"
					                                @click.stop="todetails(m.exid[k])">
                                                    <p v-html="m.exname[k].exenname!=''&&m.exname[k].exenname!=null?nToBr(m.exname[k].exenname):nToBr(s)"></p>
					                                <i v-if="m.excompany[k]!=null&&m.excompany[k]!=''"
                                                        v-html="m.exencompany[k]!=''&&m.exencompany[k]!=null?nToBr(m.exencompany[k]):nToBr(m.excompany[k])">
					                                </i>
					                            </div>
					                        </span>
					                    </van-cell>
					                </div>
					                <div class="meeting-icons">
					                    <img class="arrow" src="../../../assets/arrow-r.png">
					                </div>
					            </div>
					        </van-cell>
					    </div>
					</div>
				</template>
            </div>
        </div>
        <div class="modal" v-if="modalShow">
            <div class="details-conss">
              <DetailsNews :exid="exid" :introStatus="introShow"  @func="closeGuest"/>
            </div>
        </div>
        <van-popup v-model="showPopuop" :style="{ padding: '10%', fontSize: '14px' }">无相关会议</van-popup>
    </div>
</template>
<script>
import commonJS from '../../../lib/signUp.js'
import DetailsNews from './details-news.vue';
export default {
    name: 'searchList',
	props: ['introShow'],
    components: {
        DetailsNews
    },
    data() {
        return {
            loading: false,
            datas: [],
            showPopuop: false,
            commonMethod: {},
            search: '',
            modalShow: false,
        }
    },
    watch: {
        $route(to, from) {
            if (to.query.search != from.query.search) {
                this.search = to.query.search
                this.init()
            }
        },
    },
    created() {
        if (this.$route.query) {
            this.search = this.$route.query.search
            this.init()
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        async init() {
            try {
                this.datas = []
                this.commonMethod = new commonJS()
                this.loading = true
                const { m, search } = this.$route.query //获得路由的参数
                const _params = Object.assign({
                    m,
                    dateid: 0,
                    roomid: 0,
                    search: String(search),
                })

                const res = await this.$http.initScheduleInfo(_params)

                if (res.Code === 1000) {
                    this.$emit('searchDatas', res.childens)
                    if (res.DateListEntity.length > 0 && res.DateListEntity != null) {
                        let _list = []
                        res.DateListEntity.map((item) => {
                            let _k = []
                            for (let i in item.programListEntity) {
                                let _D = item.programListEntity[i]
                                let { programList } = _D.programs
                                for (let j in programList) {
                                    let _S = programList[j]
                                    //处理角色，人名
                                    let exData = []
                                    for (let s = 0; s < _S.expertList.length; s++) {
                                        exData = this.filterRolename(_S.expertList)
                                    }

                                    programList[j] = {
                                        url: _S.programRoom.url,
                                        exData,
                                        //中文
                                        createdTime: this.formatDate(_S.programDate.prodate),
                                        startTime: _S.starttime,
                                        endTime: _S.endtime,
                                        total: item.ProgramCount, //总数量
                                        topic: _S.topic,
                                        roomName: _S.programRoom.roomname,
                                        roomTitle: _S.programRoom.roomtitle,
                                        roleName: _S.expertList[0]?_S.expertList[0].exrolemodel.rolename:'',
                                        roomid: _S.programRoom.roomid,
                                        dateid: _S.dateid,
                                        //英文
                                        entopic: _S.entopic,
                                        roomEnName: _S.programRoom.roomenname,
                                        roomEnTitle: _S.programRoom.roomentitle,
                                        roleEnName: _S.expertList[0]?_S.expertList[0].exrolemodel.roleenname:'',
                                    }
                                    _k.push(programList[j])
                                }
                            }

                            _list.push(_k)
                        })
                        this.datas = _list
                        console.log(this.datas)
                    } else {
                        this.showPopuop = true
                    }
                }
                this.loading = false
            } catch (error) {
                console.error(error)
            }
        },
        formatTime(val) {
            let et = val.split('(')
            let end = et[1].split(')')[0]
            let endtime = Number(end)
            let date = new Date(endtime)
            let h = date.getHours()
            h = h < 10 ? '0' + h : h
            let m = date.getMinutes()
            m = m < 10 ? '0' + m : m
            return h + ':' + m
        },
        formatDate(val) {
            let et = val.split('(')
            let end = et[1].split(')')[0]
            let date = new Date(Number(end))
            let month = date.getMonth() + 1
            let day = date.getDate()
            return month + '-' + day
        },
        getSubAgendaData(data) {
            let SubAgendaData = []
            for (let k = 0; k < data.length; k++) {
                let endtime = data[k].endtime,
                    startime = data[k].starttime,
                    children = data[k].children,
                    exData = [],
                    exenname = [],
                    exid = [],
                    cncompany = [],
                    roleenname = ''
                let exnameId = []
                for (let s = 0; s < data[k].expertList.length; s++) {
                    exid.push(data[k].expertList[s].exid)

                    exenname.push(data[k].expertList[s].exenname)
                    roleenname = data[k].expertList[s].exrolemodel.roleenname
                    exnameId.push({
                        exname: data[k].expertList[s].exname,
                        exid: data[k].expertList[s].exid,
                        excompany: data[k].expertList[s].excompany,
						exenname: data[k].expertList[s].exenname,
						exencompany: data[k].expertList[s].exencompany,
                    })

                    exData = this.filterRolename(data[k].expertList)
                }

                SubAgendaData.push({
                    children,
                    startime,
                    endtime,
                    topic: data[k].topic,

                    exid,
                    exData,
                    //英文数据 ----
                    entopic: data[k].entopic,
                    exenname,
                    roleenname,
                })
            }
            return SubAgendaData
        },
        dealData(firstId, data) {
            let _temp = []
            for (let i = 0; i < data.length; i++) {
                if (data[i].upproid === firstId) {
                    _temp.push(data.splice(i, 1)[0])
                    i--
                }
            }
            for (let i = 0; i < _temp.length; i++) {
                _temp[i].children = this.dealData(_temp[i].proid, data)
            }
            return _temp
        },
        filterRolename(data) {
            let _rolenameList = [], //已去重rolename
                _rolename = [] // 所有rolename

            //去掉重复的身份（rolename）
            for (let i in data) {
                _rolename.push(data[i].exrolemodel.rolename)
                let _indexof = _rolenameList.indexOf(_rolename[i])
                if (_indexof == -1) {
                    _rolenameList.push(data[i].exrolemodel.rolename)
                }
            }
            let _identityList = [] //去重后的身份和姓名总数据
            _rolenameList.forEach((item) => {
                let _identity = { rolename: '', exname: [], exid: [], excompany: [], exenname: [], exencompany: [] }
                let _exname = [], //同一身份的嘉宾姓名
                    _exid = [],
                    _excompany = [],
						_exenname = [],
						_exencompany = [];
                for (let n in data) {
                    if (item === data[n].exrolemodel.rolename) {
                        _exname.push(data[n].exname)
                        _identity.rolename = item
                        _identity.exname = _exname
                        _exid.push(data[n].exid)
                        _identity.exid = _exid
                        _excompany.push(data[n].excompany)
                        _identity.excompany = _excompany
						_exenname.push(data[n].exenname)
						_identity.exenname = _exenname
						_exencompany.push(data[n].exencompany)
						_identity.exencompany = _exencompany
                    }
                }
                _identityList.push(_identity)
            })

            return _identityList
        },
        convertTime(time) {
            let end = time.split('(')[1].split(')')[0]
            // 将时间戳转时间格式
            let date = new Date(Number(end))
            let h = date.getHours()
            h = h < 10 ? '0' + h : h
            let m = date.getMinutes()
            m = m < 10 ? '0' + m : m
            return h + ':' + m
        },
        /**
         * @description 进入到子路由 封装的方法
         * @param {Objcet} param 路由需要的参数
         */
        todetails(param) {
            this.modalShow = true
            this.exid = param
        },
        goMeeting(e, dateid, roomid) {
            const params = {
                m: this.$route.query.m,
                roomid: roomid,
                dateid: dateid
            }
            this.$router.push({
                path: 'scheduleList',
                query: params,
            })
        },
        getIntro() {
            this.tabShow1 = true
            this.tabShow2 = false
        },
        getdetails() {
            this.tabShow1 = false
            this.tabShow2 = true
        },
        closeGuest(){
          this.modalShow = false
        },
        nToBr (str){
            if( str ){
                return str.replace(/\\n/g,'<br/>');
            }else{
                return str
            }

        },
    },
}
</script>
<style lang="scss">
.searchlist {
    .van-cell {
        &::after {
            width: 95%;
            margin: 0 auto;
            left: 0;
        }
    }
}

.modal {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 1000;
    .details-conss {
        background: #fff;
        // padding: 20px 0;
        // -webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        // box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        margin-bottom: 20px;
        //border-radius: 12px;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 10001;
        transform: translate(-50%, -50%);
        width: 90%;
        height: 80%;
        overflow-y: auto;
    }
}
</style>
<style lang="scss" scoped>
.searchlist {
    width: 100%;
    height: auto;

    .details-return {
        position: fixed;
        right: 0;
        bottom: 80px;
        width: 84px;
        height: 60px;
        z-index: 100;
        background: #3b82f6;
        border-radius: 30px 0 0 30px;
        text-align: center;
        line-height: 60px;
        color: #fff;

        img {
            height: 100%;
        }
    }

    .searchlist-con {
        padding: 20px;

        .searchlist-title {
            font-size: 30px;
            margin: 10px 0px;
        }

        .details-main {

            //padding-bottom: 30px;
            >div {
                background: #fff;
                //margin-bottom: 24px;
                // box-shadow: 0 2px 12px rgba(0,0,0,0.04);
                border-bottom: 1px solid #e2e8f0;
            }

            .meeting-list {
                display: flex;
                margin-bottom: 10px;
                padding: 10px 20px 10px 22px;
                position: relative;

                .meeting-left {
                    flex: 1
                }

                .meeting-icon {
                    position: absolute;
                    right: 0;
                    top: 10px;
                    z-index: 10;
                    width: 160px;
                    display: flex;
                    align-items: flex-end;
                    justify-content: center;
                    background: #3b82f6;
                    padding: 10px 0;
                    border-radius: 50px 0 0 50px;

                    a {
                        color: #fff;
                        display: block;
                        text-align: center;
                    }

                    img {
                        width: 30px;
                        vertical-align: -4px;
                    }

                    p {
                        font-size: 12px;
                    }
                }

                .meeting-icons {
                    width: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;

                    a {
                        color: #1e293b;
                        display: block;
                        text-align: center;
                    }

                    img {
                        width: 90px;
                    }

                    img.arrow {
                        width: 90%;
                    }
                }
            }

            .details-main-head {
                // border-bottom: 1px solid #e2e8f0;
                //padding: 10px 0px;
                padding-top: 20px;
                display: flex;

                // background: #3b82f6;
                // border-radius: 12px 12px 0 0;
                .details-main-head-date {
                    color: #3b82f6;
                    padding: 0px 0px 0px 20px;
                    font-size: 28px;

                    &>.van-icon {
                        font-size: 40px;
                        line-height: 40px;
                    }

                    &:after {
                        border: none;
                    }

                    span {
                        line-height: 40px;
                    }
                }

                .van-cell {
                    background: none;
                    color: #e6a23c;
                }

                .details-list-num {
                    width: 40px;
                    height: 40px;
                    font-size: 28px;
                    margin-right: 20px;
                    border-radius: 12px;
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                }
            }

            .details-main-con {
                position: relative;
                color: #1e293b;

                // border-bottom: 1px solid #e2e8f0;
                .major-title {
                    padding: 8px 0;
                    font-size: 26px;
                    color: #1e293b;
                    line-height: 36px;

                    >i {
                        width: 36px;
                        font-size: 36px;
                        line-height: 36px;
                    }

                    >div {
                        color: #1e293b;
                    }

                    &:after {
                        border: 0px;
                    }
                }
                .major-titles {
                    padding: 8px 160px 8px 0;
                    font-size: 26px;
                    color: #1e293b;
                    line-height: 36px;

                    >i {
                        width: 36px;
                        font-size: 36px;
                        line-height: 36px;
                    }

                    >div {
                        color: #1e293b;
                    }

                    &:after {
                        border: 0px;
                    }
                }
            }

            .details-main-con.van-cell {
                padding: 0;
            }

            #guestIntroduction-con {
                min-height: 300px;
                margin-top: 20px;

                >h4 {
                    font-size: 30px;
                    padding-left: 20px;
                    height: 60px;
                    line-height: 60px;
                    border-bottom: 1px solid #e2e8f0;
                    padding: 16px 0px;
                    display: flex;
                    background: #3b82f6;
                    border-radius: 12px 12px 0 0;
                }

                >p {
                    width: 90%;
                    margin: 0 auto;
                    padding: 20px 0;
                    line-height: 54px;
                }
            }
        }
    }
}
</style>
